/** Rewrite API-built app links that still point at localhost to the current host. */
export function toPublicAppUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return pathOrUrl;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  try {
    const url = /^https?:\/\//i.test(pathOrUrl)
      ? new URL(pathOrUrl)
      : new URL(pathOrUrl, origin || 'http://localhost');
    if (origin && (url.hostname === 'localhost' || url.hostname === '127.0.0.1')) {
      return `${origin}${url.pathname}${url.search}${url.hash}`;
    }
    return url.toString();
  } catch {
    return pathOrUrl;
  }
}
